import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  card: {
    marginBottom: 12,
  },
  cardContent: {
    paddingBottom: "16px !important",
  },
  row: {
    marginBottom: 12,
  },
  assessmentName: {
    fontWeight: 500,
    fontSize: 15,
    marginBottom: 8,
  },
  infoGrid: {
    marginTop: 4,
  },
  label: {
    fontSize: 12,
    color: "#666",
    marginBottom: 4,
  },
  value: {
    fontWeight: 500,
    fontSize: 14,
  },
  totalContainer: {
    marginTop: 16,
    paddingTop: 12,
    borderTop: "2px solid #e0e0e0",
  },
  total: {
    fontSize: 16,
    fontWeight: 600,
    textAlign: "right",
  },
});

export default function PurchaseCard(props) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        {(props.rows || []).map((row, index) => (
          <div key={row.id}>
            {index > 0 && <Divider style={{ marginTop: 12, marginBottom: 12 }} />}
            <div className={classes.row}>
              <Typography className={classes.assessmentName}>
                {row.name}
              </Typography>
              <Grid container spacing={2} className={classes.infoGrid}>
                <Grid item xs={6}>
                  <Typography className={classes.label}>
                    {t("activity:tableHeaders.quantity")}
                  </Typography>
                  <Typography className={classes.value}>
                    {row.quantity}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.label}>
                    {t("activity:tableHeaders.cost", { currency: props.currency })}
                  </Typography>
                  <Typography className={classes.value} style={{ color: "#006EB3" }}>
                    {row.subtotal}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </div>
        ))}

        <div className={classes.totalContainer}>
          <Typography className={classes.total}>
            {t("activity:total")}:{" "}
            {(
              parseFloat(props.total) ||
              0 + parseFloat(props.discount) ||
              0
            ).toFixed(2)}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
